import { Link as HashLink } from "react-scroll";
import { Link } from "gatsby";
import "twin.macro";
import arrow from "../../icons/arrow.svg";
import React from "react";
import home from "../../icons/home.svg";
import { Flip, Zoom, Roll } from "react-reveal";
import { motion } from "framer-motion";

const HomeSection = () => {
  return (
    <div
      tw="flex flex-col items-center justify-center min-h-screen p-4 space-y-20 bg-gray-700 bg-no-repeat bg-cover bg-center"
      style={{ backgroundImage: `url(${home})` }}
    >
      <div tw="flex relative flex-col items-center space-y-0 overflow-hidden">
        <Flip>
          <p tw="text-white font-bold text-2xl md:text-4xl lg:text-7xl max-w-5xl text-center">
            A startup behind your startup
          </p>
        </Flip>

        <Roll tw="absolute max-w-sm    m-0  ">
          <img src={arrow} tw="h-24 max-w-sm md:h-auto" alt="" />
        </Roll>
        <div tw="max-w-sm    md:h-auto m-0 " alt="" />

        <Zoom>
          <p tw="text-gray-100  font-medium max-w-4xl md:text-2xl text-center">
            Bundled with lots of Cutting edge technological solutions for you
            and your enterprise
          </p>
        </Zoom>
      </div>

      <div tw="flex items-center  space-x-4">
        <Link to="portfolio_websites">
          <motion.div
            whileTap={{ scale: 0.9 }}
            whileHover={{ scale: 1.1, borderRadius: "15px" }}
            transition={{ delay: 0.1 }}
            tw=" bg-red-600 hover:(bg-white text-red-600 shadow-xl) h-full cursor-pointer p-5 no-underline text-white font-bold rounded transition"
          >
            Portfolio websites
          </motion.div>
        </Link>

        <HashLink to="contact" spy={true} smooth={true} duration={500}>
          <motion.div
            whileTap={{ scale: 0.9 }}
            whileHover={{ scale: 1.1, borderRadius: "20px" }}
            transition={{ delay: 0.1 }}
            tw="border border-white h-full rounded border-solid hover:(bg-white text-red-600 border-white shadow-xl)  cursor-pointer p-5 transition  no-underline text-white font-bold"
          >
            Contact Us
          </motion.div>
        </HashLink>
      </div>
    </div>
  );
};

export default HomeSection;
